// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1TXJx","inputWrap":"CustomTip_inputWrap__3I9BS"};